module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-11.59116dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-11.jpg
// module id = hzIK
// module chunks = 0